import * as constants from './constants';
import getDefaultListViewType from './utils/getDefaultListViewType';
import { logUsage } from 'owa-analytics';
import isConsumer from 'owa-session-store/lib/utils/isConsumer';
import { getIsBitSet } from 'owa-bit-flags/lib/utils/listViewBitFlagsUtil';
export default function getDefaultSettings(userConfig) {
    if (shouldUserGetReactSettings(userConfig)) {
        return null; /* No default settings since we can use React settings from server */
    }
    logUsage('settingUpdate');
    var userOptions = userConfig.UserOptions;
    // Otherwise, return settings from JSMVVM
    return {
        GlobalReadingPanePositionReact: userOptions.GlobalReadingPanePosition /* Whatever is in jsMVVM */,
        ConversationSortOrderReact: userOptions.ConversationSortOrder /* Whatever is in jsMVVM */,
        GlobalListViewTypeReact: getDefaultListViewType(userConfig) /* Whatever is in jsMVVM */,
    };
}
function shouldUserGetReactSettings(userConfig) {
    var userOptions = userConfig.UserOptions;
    if (isConsumer()) {
        return (
        // User has not been force-optin
        !(userOptions.ReactOptinSettings &&
            userOptions.ReactOptinSettings.MailGraduatedFromBeta) ||
            // User have opted-in previously
            userOptions.ClientTypeOptInState === 2 /* React */ ||
            // This is not the first time in this experiment
            (userOptions.NewEnabledPonts & constants.DefaultSettingPont) === 0);
    }
    else {
        return getIsBitSet(32 /* IsCommercialUserInitialized */);
    }
}
//# sourceMappingURL=getDefaultSettings.js.map